<!--
  ProfileDropdown.vue
  ============================
 【功能簡介】
  此元件為導覽列最右側的個人選單下拉元件：
  - 顯示使用者名稱與圖示 (小螢幕僅顯示圖示)
  - 點擊後開啟下拉選單，顯示可選操作清單（如登出）
  - 根據 props 接收不同選單項目與分組配置
  - 自動從 localStorage 讀取並顯示 userName
-->

<template>
  <div class="profile-dropdown-wrapper">
    <VaDropdown v-model="isShown" class="profile-dropdown" stick-to-edges>
      <template #anchor>
        <VaButton preset="secondary" color="textPrimary" class="place-content-center">
          <span class="profile-dropdown__anchor min-w-max flex items-center">
            <VaIcon name="fas fa-user-circle" :size="32" class="mr-3" color="#FFFFFF" />
            <span class="username mr-2 text-white text-lg">{{ userName }}</span>
          </span>
        </VaButton>
      </template>
      <VaDropdownContent
        class="profile-dropdown__content w-44 px-0 py-4"
        :style="{ '--hover-color': 'rgba(64, 130, 109, 0.1)' }"
      >
        <VaList v-for="group in options" :key="group.name">
          <VaListItem
            v-for="item in group.list"
            :key="item.name"
            class="menu-item px-4 text-base cursor-pointer h-8"
            v-bind="resolveLinkAttribute(item)"
          >
            <VaIcon :name="item.icon" class="pr-1" color="secondary" />
            <span class="text-lg ml-2">{{ item.name }}</span>
          </VaListItem>
          <VaListSeparator v-if="group.separator" class="mx-3 my-2" />
        </VaList>
      </VaDropdownContent>
    </VaDropdown>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'

const { colors, setHSLAColor } = useColors()
const hoverColor = computed(() => setHSLAColor(colors.focus, { a: 0.1 }))

const { t } = useI18n()
const userName = ref()

type ProfileListItem = {
  name: string
  to?: string
  href?: string
  icon: string
}

type ProfileOptions = {
  name: string
  separator: boolean
  list: ProfileListItem[]
}

withDefaults(
  defineProps<{
    userName?: string
    options?: ProfileOptions[]
  }>(),
  {
    userName: '',
    options: () => [
      {
        name: 'account',
        separator: false,
        list: [
          // {
          //   name: 'settings',
          //   to: 'settings',
          //   icon: 'mso-settings',
          // },
          {
            name: '登出',
            to: 'login',
            icon: 'mso-logout',
          },
        ],
      },
    ],
  },
)

const isShown = ref(false)

const resolveLinkAttribute = (item: ProfileListItem) => {
  return item.to ? { to: { name: item.to } } : item.href ? { href: item.href, target: '_blank' } : {}
}

onMounted(async () => {
  userName.value = localStorage.getItem('userName')
  console.log(userName.value)
})
</script>

<style lang="scss">
.profile-dropdown {
  cursor: pointer;

  &__content {
    .menu-item:hover {
      background: var(--hover-color);
    }
  }

  &__anchor {
    display: inline-block;
  }
}
@media screen and (max-width: 640px) {
  .username {
    display: none;
  }
}
</style>
